import graphql from "babel-plugin-relay/macro";
import { commitMutation } from "react-relay";

import { environment } from "pstat-anywhere/relay";

const mutation = graphql`
  mutation ProxyLoginReverseMutation {
    reverseProxyLogin {
      ok
      reasons
    }
  }
`;

export const doProxyLoginReverse = () => {
  commitMutation(environment, {
    mutation,
    onCompleted: (response, errors) => {
      const { ok } = response.reverseProxyLogin;
      if (ok) {
        window.location.reload(true);
      }
    },
    onError: err => {
      if (err) {
        throw new Error(err);
      }
    }
  });
};
